import { Component, Input, OnInit } from '@angular/core';
import { PreliminaryInstallmentDto } from '@app/service/credit/credit.service';

@Component({
  selector: 'app-preliminary-installments',
  templateUrl: './preliminary-installments.component.html',
  styleUrls: ['./preliminary-installments.component.scss'],
})
export class PreliminaryInstallmentsComponent implements OnInit {
  @Input() installmentPlans: PreliminaryInstallmentDto[] = [];
  @Input() primaryColor: string;

  selectedPlan: PreliminaryInstallmentDto;

  ngOnInit(): void {
    if (this.installmentPlans.length) {
      this.selectedPlan = this.installmentPlans[0];
    }
  }

  select(index: number): void {
    this.selectedPlan = this.installmentPlans[index];
  }

  getTitleString(monthlyCost: number, numberOfMonths: number): string {
    return `${monthlyCost.toLocaleString('sv', { maximumFractionDigits: 0 })} SEK/mån i ${numberOfMonths} månader`;
  }

  getBulletPoints(item: PreliminaryInstallmentDto): string[] {
    return [`Årsränta ${item.nominalInterest.toFixed(2)}%`];
  }

  isZeroInterest(item: PreliminaryInstallmentDto): boolean {
    return item.nominalInterest < 0.001;
  }

  isFirstItem(index: number): boolean {
    return index === 0;
  }

  isLastItem(index: number): boolean {
    return index === this.installmentPlans.length - 1;
  }
}
